module.exports = __webpack_public_path__ + "img/14.9959c041.png";